import * as React from 'react';

import CenteredLoadingIndicator from 'components/CenteredLoadingIndicator';
// @ts-ignore
import TargetByStudentIdContainer from './TargetByStudentIdContainer';
// @ts-ignore
import TargetByStudentIdPanel from './TargetByStudentIdPanel';
import { StudentIdListRecipient, ComposerOrganization } from 'types/typescript/messagingTypes';
import { TargetByStudentIdPages } from './SelectRecipientPanel';
import { ComposerRecipients_composerRecipients_recipients_ComposerRecipientListEntity } from 'chat_v2/components/SplitComposer/queries/__generated__/ComposerRecipients';

type Props = {
  onContinue: () => void;
  onPageChange: (page: TargetByStudentIdPages) => void;
  schools?: Partial<ComposerOrganization>[];
  studentIdListRecipientInSelection?: ComposerRecipients_composerRecipients_recipients_ComposerRecipientListEntity;
};

export default class TargetByStudentId extends React.Component<Props> {
  render() {
    if (!this.props.schools) {
      return <CenteredLoadingIndicator />;
    }

    const schoolUuids = this.props.schools.map(school => school.uuid);
    return (
      <TargetByStudentIdContainer schoolUuids={schoolUuids}>
        {(props: any) => (
          <TargetByStudentIdPanel
            {...props}
            onContinue={this.props.onContinue}
            onPageChange={this.props.onPageChange}
            studentIdListRecipientInSelection={this.props.studentIdListRecipientInSelection}
          />
        )}
      </TargetByStudentIdContainer>
    );
  }
}
